"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _redux = require("redux");
var _auth = _interopRequireDefault(require("./auth/auth.reducer"));
var _records = _interopRequireDefault(require("./records/records.reducer"));
var _reportRendering = _interopRequireDefault(require("./report/reportRendering/reportRendering.reducer"));
var _siteRendering = _interopRequireDefault(require("./site/siteRendering/siteRendering.reducer"));
var _siteForTenant = _interopRequireDefault(require("./site/siteRead/siteForTenant.reducer"));
var _organizationInfoForTenant = _interopRequireDefault(require("./organizationInfoForTenant/organizationInfoForTenant.reducer"));
var _reportForTenant = _interopRequireDefault(require("./report/report/reportForTenant.reducer"));
var _reportPrintBridgeForTenant = _interopRequireDefault(require("./printBridge/reportPrintBridgeForTenant/reportPrintBridgeForTenant.reducer"));
var _fundForTenant = _interopRequireDefault(require("./records/fund/fundForTenant.reducer"));
var _reportUpdateForTenant = _interopRequireDefault(require("./report/reportUpdate/reportUpdateForTenant.reducer"));
var _fund = _interopRequireDefault(require("./reportData/fund/fund.reducer"));
var _analyticSession = _interopRequireDefault(require("./analytics/analyticSession/analyticSession.reducer"));
var _socket = _interopRequireDefault(require("./socket/socket.reducer"));
var _metadata = _interopRequireDefault(require("./records/render/metadata.reducer"));
var _assetsForTenant = _interopRequireDefault(require("./assets/assetsForTenant/assetsForTenant.reducer"));
var _donorForTenant = _interopRequireDefault(require("./records/donorForTenant/donorForTenant.reducer"));
var _sessionAlert = _interopRequireDefault(require("./analytics/sessionAlert/sessionAlert.reducer"));
var _tenantInteraction = _interopRequireDefault(require("./contentPanel/tenantInteraction/tenantInteraction.reducer"));
var _survey = _interopRequireDefault(require("./surveyor/survey/survey.reducer"));
var _surveyForTenant = _interopRequireDefault(require("./surveyor/surveyForTenant/surveyForTenant.reducer"));
var _surveyRendering = _interopRequireDefault(require("./surveyor/surveyRendering/surveyRendering.reducer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow
var _default = (0, _redux.combineReducers)({
  socket: _socket.default,
  authTenant: _auth.default,
  records: _records.default,
  reportRendering: _reportRendering.default,
  siteRendering: _siteRendering.default,
  siteReadForTenant: _siteForTenant.default,
  organizationInfoForTenant: _organizationInfoForTenant.default,
  report: _reportForTenant.default,
  reportPrintBridgeForTenant: _reportPrintBridgeForTenant.default,
  fundForTenant: _fundForTenant.default,
  reportUpdateForTenant: _reportUpdateForTenant.default,
  reportDataFundForTenant: _fund.default,
  analyticSessionForTenant: _analyticSession.default,
  metadataForTenant: _metadata.default,
  assetsForTenant: _assetsForTenant.default,
  donorForTenant: _donorForTenant.default,
  sessionAlert: _sessionAlert.default,
  interactionReducer: _tenantInteraction.default,
  surveyForTenantLogin: _survey.default,
  surveyForTenant: _surveyForTenant.default,
  surveyForRendering: _surveyRendering.default
});
exports.default = _default;